import React, { useState, useEffect } from "react";
import { View, Text, XStack, YStack } from "tamagui";
import { RiBankCardLine, RiShieldCheckLine } from "react-icons/ri";
import { colors } from "@styles/colors";

export default function Processing({ message = "透過 TapPay 安全加密通道\n驗證你的信用卡資訊" }: { message?: string }) {
  const [dots, setDots] = useState("");
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const dotsInterval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? "" : prev + "."));
    }, 500);

    const pulseInterval = setInterval(() => {
      setPulse((prev) => !prev);
    }, 1000);

    return () => {
      clearInterval(dotsInterval);
      clearInterval(pulseInterval);
    };
  }, []);

  return (
    <YStack bg={colors.bg} f={1} ai="center" jc="center" p="0 32px">
      <View
        w={76}
        h={76}
        br={38}
        bg={colors.primaryActive}
        ai="center"
        jc="center"
        mb="$6"
        position="relative"
        animation="medium"
        scale={pulse ? 1.1 : 1}
        opacity={pulse ? 0.7 : 1}
      >
        <RiBankCardLine size={32} color={colors.primary} />
      </View>
      <XStack h={27} ai="center" mb="$2">
        <Text fontSize={18} fontWeight="800" color={colors.grayDark}>
          處理中
        </Text>
        <Text fontSize={18} fontWeight="800" color={colors.grayDark} w={20}>
          {dots}
        </Text>
      </XStack>
      <Text fontSize={12} color={colors.gray200} ta="center" my="$3">
        {message}
      </Text>
      <XStack ai="center" gap="$1" bg={`${colors.green}15`} bw={1} bc={`${colors.green}30`} br={14} px="$3" py="$1">
        <RiShieldCheckLine size={16} color={colors.green} />
        <Text fontSize={12} fontWeight="800" color={colors.green} ls={0.3}>
          SSL 256-bit 加密保護
        </Text>
      </XStack>
    </YStack>
  );
}
